<template>
    <div class="type_area" style="display: flex;padding-top: 18px;">
        <div class="left">
            <div class="storeName">
                <div style="display: flex;align-items: center;" v-if="!noAuthCols.includes('CompanyName')">
                    <div style="margin-right: 10px;"><img src="//assets/images/storeTag.svg" alt=""></div>
                    <div style="font-weight: bold;font-size: 18px;color: #222222;font-family: PingFang SC, PingFang SC;">{{baseInfo.CompanyName?baseInfo.CompanyName:'--'}}</div>
                </div>
                <div style="display: flex;margin-top: 10px;font-family: PingFang SC, PingFang SC;">
                    <div v-if="baseInfo.ShopType=='法人多店'||baseInfo.ShopType=='批零一体'||baseInfo.ShopType=='连锁企业'||baseInfo.ShopType=='单体诊疗'||baseInfo.ShopType=='商业公司'||baseInfo.ShopType=='商联'||baseInfo.ShopType=='医疗机构'" class="fox" style="border-color:#C750EB ;background-color: #FDF5FF;color: #C750EB;">{{baseInfo.ShopType}}</div>
                    <div v-if="baseInfo.SettlementType=='月结'||baseInfo.SettlementType=='预付'||baseInfo.SettlementType=='月清'||baseInfo.SettlementType=='账期'||baseInfo.SettlementType=='实销月结'||baseInfo.SettlementType=='押批'" class="fox" style="border-color:#F76A35 ;background-color: #FFF2EE;color: #F76A35;">{{baseInfo.SettlementType}}</div>
                    <div v-for="(item,index) in baseInfo.CooperateType" :key="index">
                        <div v-if="item=='金鹰'||item=='深联'" class="fox" style="border-color:#39CEAC ;background-color: #DEF6F0;color: #39CEAC;">{{item}}</div>
                        <div v-if="item=='星锐'||item=='普通'" class="fox" style="border-color:#47BE3A ;background-color: #F6FFED;color: #47BE3A;">{{item}}</div>
                        <div v-if="item=='创享汇'||item=='其他战略'" class="fox" style="border-color:#1A9DFF ;background-color: #E4F4FF;color: #1A9DFF;">{{item}}</div>
                    </div>

                </div>
            </div>
            <div>
                <div style="display: flex;margin-bottom: 7px;" v-if="!noAuthCols.includes('SupplySystems')">
                    <div class="title">供价体系</div>
                    <div class="detail">{{ baseInfo.SupplySystems ?baseInfo.SupplySystems:'--' }}</div>
                </div>
                <div style="display: flex;margin-bottom: 7px;" v-if="!noAuthCols.includes('Contacter')">
                    <div class="title">联系人</div>
                    <div class="detail">{{baseInfo.Contacter?baseInfo.Contacter:'--' }}</div>
                </div>
                <div style="display: flex;margin-bottom: 7px;" v-if="!noAuthCols.includes('MainBusinessArea')">
                    <div class="title">主营区域</div>
                    <div class="detail">{{baseInfo.MainBusinessArea ?baseInfo.MainBusinessArea:'--' }}</div>
                </div>
                <div style="display: flex;margin-bottom: 7px;" v-if="!noAuthCols.includes('DirectSaleNum')">
                    <div class="title">直营门店</div>
                    <div class="detail">{{baseInfo.DirectSaleNum ?baseInfo.DirectSaleNum:'--'}}</div>
                </div>
                <div style="display: flex;margin-bottom: 7px;" v-if="!noAuthCols.includes('FranchiseSaleNum')">
                    <div class="title">加盟门店</div>
                    <div class="detail">{{baseInfo.FranchiseSaleNum?baseInfo.FranchiseSaleNum:'--' }}</div>
                </div>
                <div style="display: flex;margin-bottom: 7px;" v-if="!noAuthCols.includes('SalesVolume')">
                    <div class="title">销售规模</div>
                    <div class="detail">{{baseInfo.SalesVolume?baseInfo.SalesVolume:'--' }}</div>
                </div>
                <div style="display: flex;margin-bottom: 7px;" v-if="!noAuthCols.includes('DistributorInfo')">
                    <div class="title">地区经理</div>
                    <div class="detail">{{baseInfo.DistributorInfo ?baseInfo.DistributorInfo:'--' }}</div>
                </div>
                <div style="display: flex;" v-if="!noAuthCols.includes('BusinessRegion')">
                    <div class="title">所属省办</div>
                    <div class="detail">{{baseInfo.BusinessRegion ?baseInfo.BusinessRegion:'--' }}</div>
                </div>

            </div>
        </div>
        <div>
            <div class="right1">
                <div class="box_title">销售回款数据</div>
                <div style="display: flex;padding: 8px 8px 0 8px;justify-content: space-between;">
                    <div v-if="!noAuthCols.includes('ThisYearSales')">
                        <div class="kind">本年度年销售金额</div>
                        <div class="kindDetail">{{saleBackData.ThisYearSales?saleBackData.ThisYearSales:'0' }}</div>
                    </div>
                    <div v-if="!noAuthCols.includes('LastYearSales')">
                        <div class="kind">上年度年销售金额</div>
                        <div class="kindDetail">{{saleBackData.LastYearSales?saleBackData.LastYearSales:'0' }}</div>
                    </div>
                    <div v-if="!noAuthCols.includes('SalesLv')">
                        <div class="kind">销售同比</div>
                        <div class="kindDetail">{{saleBackData.SalesLv?saleBackData.SalesLv:'0%' }}</div>
                    </div>
                    <div v-if="!noAuthCols.includes('ThisYearBack')">
                        <div class="kind">本年度年回款金额</div>
                        <div class="kindDetail">{{saleBackData.ThisYearBack?saleBackData.ThisYearBack:'0' }}</div>
                    </div>
                    <div v-if="!noAuthCols.includes('LastYearBack')">
                        <div class="kind">上年度年回款金额</div>
                        <div class="kindDetail">{{saleBackData.LastYearBack?saleBackData.LastYearBack:'0' }}</div>
                    </div>
                    <!-- <div>
                        <div class="kind">回款同比</div>
                        <div class="kindDetail">{{saleBackData.}}</div>
                    </div> -->
                </div>
                <div class="line"></div>
                <div style="display: flex;padding: 8px 8px 0 8px;">
                    <div v-if="!noAuthCols.includes('BackLv')">
                        <div class="kind">回款同比</div>
                        <div class="kindDetail">{{saleBackData.BackLv?saleBackData.BackLv:'0%' }}</div>
                    </div>
                </div>
            </div>
            <div class="right2">
                <div class="box_title">合作品种数据</div>
                <div style="display: flex;padding: 8px 8px 0 8px;justify-content: space-between;">
                    <div v-if="!noAuthCols.includes('ThisYearGoodsNum')">
                        <div class="kind">本年度合作数</div>
                        <el-link class="kindDetail" style="color: #337CFF;" @click="tabNum=1,cooperateDetail()">{{cooperateGoodsData.ThisYearGoodsNum?cooperateGoodsData.ThisYearGoodsNum:'0' }}</el-link>
                    </div>
                    <div v-if="!noAuthCols.includes('LastYearGoodsNum')">
                        <div class="kind">上年度合作数</div>
                        <el-link class="kindDetail" style="color: #337CFF;" @click="tabNum=2,cooperateDetail()">{{cooperateGoodsData.LastYearGoodsNum?cooperateGoodsData.LastYearGoodsNum:'0' }}</el-link>
                    </div>
                    <div v-if="!noAuthCols.includes('KeynoteGoodsNum')">
                        <div class="kind">重点产品合作数</div>
                        <el-link class="kindDetail" style="color: #337CFF;" @click="tabNum=3,cooperateDetail()">{{cooperateGoodsData.KeynoteGoodsNum?cooperateGoodsData.KeynoteGoodsNum:'0' }}</el-link>
                    </div>
                    <div v-if="!noAuthCols.includes('BargainGoodsNum')">
                        <div class="kind">议价品种数</div>
                        <el-link class="kindDetail" style="color: #337CFF;" @click="tabNum=4,cooperateDetail()">{{cooperateGoodsData.BargainGoodsNum?cooperateGoodsData.BargainGoodsNum:'0' }}</el-link>
                    </div>
                    <div v-if="!noAuthCols.includes('BargainSaleLv')">
                        <div class="kind">议价销售比例</div>
                        <div class="kindDetail">{{cooperateGoodsData.BargainSaleLv?cooperateGoodsData.BargainSaleLv:'0' }}</div>

                    </div>
                </div>
            </div>
            <div class="right3">
                <el-tabs v-model="activeName">
                    <el-tab-pane label="协议条款" name="first" style="background-color: #f7f8fa;">
                        <div v-if="profectList.length">
                            <div v-for="(item,index) in profectList" :key="index" style="display: flex;justify-content: space-between;margin-bottom: 12px;  padding: 12px;background-color: #fff;">
                                <div style="flex: 1;">
                                    <div style="display: flex;margin-bottom: 7px;">
                                        <div class="title1">协议类型</div>
                                        <div class="detail">{{item.AgreementType?item.AgreementType:'--' }}</div>
                                    </div>
                                    <div style="display: flex;margin-bottom: 7px;">
                                        <div class="title1">协议期限</div>
                                        <div class="detail">{{item.DateRange?item.DateRange:'--' }}</div>
                                    </div>
                                    <div style="display: flex;margin-bottom: 7px;">
                                        <div class="title1">结算方式</div>
                                        <div class="detail">{{item.ReceiveType?item.ReceiveType:'--' }}</div>
                                    </div>
                                    <div style="display: flex;margin-bottom: 7px;">
                                        <div class="title1">结款周期</div>
                                        <div class="detail">{{item.ReceiveTime?item.ReceiveTime:'--' }}</div>
                                    </div>
                                    <div v-if="item.isShow" style="display: flex;margin-bottom: 7px;">
                                        <div class="title1">原件是否备案</div>
                                        <div class="detail">{{item.Original?item.Original:'--' }}</div>
                                    </div>
                                    <div v-if="item.isShow&&item.T==3" style="display: flex;margin-bottom: 7px;">
                                        <div class="title1">产品名称</div>
                                        <div class="detail" style="color: #F92B2B;">{{item.ProductName?item.ProductName:'--' }}</div>
                                    </div>
                                    <div v-if="item.isShow&&item.T==3" style="display: flex;margin-bottom: 7px;">
                                        <div class="title1">规格/型号</div>
                                        <div class="detail">{{item.Norms?item.Norms:'--' }}</div>
                                    </div>
                                    <div v-if="item.isShow&&item.T==3" style="display: flex;margin-bottom: 7px;">
                                        <div class="title1">单价</div>
                                        <div class="detail">{{item.Price?item.Price:'--' }}</div>
                                    </div>
                                    <div v-if="item.isShow&&item.T!=1" style="display: flex;margin-bottom: 7px;">
                                        <div class="title1">返利周期</div>
                                        <div class="detail">{{item.RebackTime?item.RebackTime:'--' }}</div>
                                    </div>
                                    <div v-if="item.isShow&&item.T!=1" style="display: flex;margin-bottom: 7px;">
                                        <div class="title1">返利形式</div>
                                        <div class="detail">{{item.RebackType?item.RebackType:'--' }}</div>
                                    </div>
                                    <div v-if="item.isShow" style="display: flex;margin-bottom: 7px;">
                                        <div class="title1">铺底金额</div>
                                        <div class="detail">{{item.OriginalMoneyStr?item.OriginalMoneyStr:'--' }}</div>
                                    </div>
                                    <div v-if="item.isShow&&item.T==2" style="display: flex;margin-bottom: 7px;">
                                        <div class="title1">项目内容</div>
                                        <div class="detail">{{item.Content?item.Content:'--' }}</div>
                                    </div>
                                    <div v-if="item.isShow" style="display: flex;margin-bottom: 7px;">
                                        <div class="title1">补充条款</div>
                                        <div class="detail">{{item.SupplementaryClauses?item.SupplementaryClauses:'--' }}</div>
                                    </div>
                                    <div v-if="item.isShow&&item.T!=3" style="display: flex;margin-bottom: 7px;">
                                        <div class="title1">产权协议</div>
                                        <div class="detail">{{item.RightsAgreement?item.RightsAgreement:'--' }}</div>
                                    </div>
                                    <div v-if="item.isShow&&item.T!=1" style="display: flex;width: 730px;">
                                        <el-table :data="item.tableOne" :header-cell-style="{'text-align':'center', 'background': '#f7f8fa',}" :cell-style="{'text-align':'center'}" style="margin-right: 12px;height: 140px;">
                                            <el-table-column :label="item.T==2?'协议量(万元)':'协议量(盒)'">
                                                <el-table-column prop="AgreementMoney1" label="一档">
                                                </el-table-column>
                                                <el-table-column prop="AgreementMoney2" label="二档">
                                                </el-table-column>
                                            </el-table-column>
                                            <el-table-column label="返点比例">
                                                <el-table-column prop="RebackLv1" label="一档">
                                                </el-table-column>
                                                <el-table-column prop="RebackLv2" label="二档">
                                                </el-table-column>
                                            </el-table-column>
                                        </el-table>
                                        <el-table :header-cell-style="{'text-align':'center','background': '#f7f8fa',}" :cell-style="{'text-align':'center', }" :data="item.TargetDetail" border :style="{'max-width':'100%', }">
                                            <el-table-column prop="StartDate" label="考核时间" width="200">
                                                <template slot-scope="scope">
                                                    <div> {{ scope.row.StartDate+'至'+scope.row.EndDate }}</div>
                                                </template>
                                            </el-table-column>
                                            <el-table-column prop="Target" label="任务目标">
                                            </el-table-column>
                                            <el-table-column prop="Complete" label="完成情况">
                                            </el-table-column>
                                            <el-table-column prop="Lv" label="完成进度">
                                            </el-table-column>
                                        </el-table>
                                    </div>
                                </div>
                                <div @click="expand(item,index)" style="color: #337CFF;font-family: PingFang SC, PingFang SC;  font-weight: 500;font-size: 14px;display: flex;align-items: center;height: 20px;cursor: pointer;">
                                    <div style="margin-right: 4px;">{{ item.isShow?'收起':'展开协议'  }}</div>
                                    <img src="//assets/images/arrowD.svg" alt="">
                                </div>
                            </div>
                        </div>
                        <div v-else class="nodata_box">
                            <img src="@/assets/images/index/nodata.png" />
                            <span class="txt">暂无数据哦~</span>
                        </div>
                        <div class="pagination_box">
                            <el-pagination background layout="prev, pager, next, sizes, total" :page-sizes="[10, 20, 30, 40]" :page-size.sync="paramsData.pageSize" :current-page.sync="paramsData.page" :total="totalData" @current-change="getProfect" @size-change="getProfect(1)">
                            </el-pagination>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="费用投入" name="second" style="padding: 12px;">
                        <div style="display: flex;justify-content: space-between;">
                            <div class="fee">
                                <div style="display: flex;justify-content: space-between;">
                                    <div style="font-family: PingFang SC, PingFang SC;font-weight: bold;font-size: 14px;color: #333333;">本年度费用投入</div>
                                    <div @click="expandFee(1)" style="color: #337CFF;font-family: PingFang SC, PingFang SC;  font-weight: 500;font-size: 14px;display: flex;align-items: center;height: 20px;cursor: pointer;">
                                        <div style="margin-right: 4px;">{{fee1?'收起': '展开明细'  }}</div>
                                        <img v-if="fee1" src="//assets/images/takein.svg" alt="">
                                        <img v-else src="//assets/images/arrowD.svg" alt="">
                                    </div>
                                </div>
                                <div style="display: flex;justify-content: space-between;">
                                    <div  v-if="!noAuthCols.includes('PromotionFee')">
                                        <div class="word">促销费</div>
                                        <div class="num">{{feeData1.PromotionFee?feeData1.PromotionFee:'0' }}</div>
                                    </div>
                                    <div  v-if="!noAuthCols.includes('ExpensesFee')">
                                        <div class="word">动销费</div>
                                        <div class="num">{{feeData1.ExpensesFee?feeData1.ExpensesFee:'0' }}</div>
                                    </div>
                                    <div  v-if="!noAuthCols.includes('SponsorshipFee')">
                                        <div class="word">赞助费</div>
                                        <div class="num">{{feeData1.SponsorshipFee?feeData1.SponsorshipFee:'0' }}</div>
                                    </div>
                                    <div v-if="!noAuthCols.includes('OtherFee')">
                                        <div class="word">其他费</div>
                                        <div class="num">{{feeData1.OtherFee?feeData1.OtherFee:'0' }}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="fee">
                                <div style="display: flex;justify-content: space-between;">
                                    <div style="font-family: PingFang SC, PingFang SC;font-weight: bold;font-size: 14px;color: #333333;">上年度费用投入</div>
                                    <div @click="expandFee(2)" style="color: #337CFF;font-family: PingFang SC, PingFang SC;  font-weight: 500;font-size: 14px;display: flex;align-items: center;height: 20px;cursor: pointer;">
                                        <div style="margin-right: 4px;">{{fee2?'收起': '展开明细'  }}</div>
                                        <img v-if="fee2" src="//assets/images/takein.svg" alt="">
                                        <img v-else src="//assets/images/arrowD.svg" alt="">
                                    </div>
                                </div>
                                <div style="display: flex;justify-content: space-between;">
                                    <div  v-if="!noAuthCols.includes('PromotionFee')">
                                        <div class="word">促销费</div>
                                        <div class="num">{{feeData2.PromotionFee?feeData2.PromotionFee:'0' }}</div>
                                    </div>
                                    <div  v-if="!noAuthCols.includes('ExpensesFee')">
                                        <div class="word">动销费</div>
                                        <div class="num">{{feeData2.ExpensesFee?feeData2.ExpensesFee:'0' }}</div>
                                    </div>
                                    <div  v-if="!noAuthCols.includes('SponsorshipFee')">
                                        <div class="word">赞助费</div>
                                        <div class="num">{{feeData2.SponsorshipFee?feeData2.SponsorshipFee:'0' }}</div>
                                    </div>
                                    <div v-if="!noAuthCols.includes('OtherFee')">
                                        <div class="word">其他费</div>
                                        <div class="num">{{feeData2.OtherFee?feeData2.OtherFee:'0' }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                       <div v-if="feeList.length">
                        <div v-for="item in feeList" :key="item" style="margin: 20px 0;">
                            <div style="display: flex;justify-content: space-between;margin-bottom: 6px;">
                                <div style="font-family: PingFang SC, PingFang SC;font-weight: bold;font-size: 15px;color: #333333;">{{item.title}}</div>
                                <div style="font-family: PingFang SC, PingFang SC;font-weight: 500;font-size: 14px;color: #353535;">{{ item.date }}</div>
                            </div>
                            <div style="font-family: PingFang SC, PingFang SC;font-weight: 500;font-size: 13px;color: #999999;">{{ item.content }}</div>
                            <div class="line"></div>
                        </div>
                       </div>
                        <div v-if="!feeList.length&&(fee1||fee2)" class="nodata_box">
                            <img src="@/assets/images/index/nodata.png" />
                            <span class="txt">暂无更多~~~</span>
                        </div>
                        <!-- <div class="pagination_box">
                            <el-pagination background layout="prev, pager, next, sizes, total" :page-sizes="[10, 20, 30, 40]" :page-size.sync="params1.pageSize" :current-page.sync="params1.page" :total="total1" @current-change="getFee" @size-change="getFee(1)">
                            </el-pagination>
                        </div> -->
                    </el-tab-pane>
                    <el-tab-pane label="项目服务" name="third" style="padding: 12px;">
                        <div style="display: flex;justify-content: space-between;">
                            <div class="fee">
                                <div style="display: flex;justify-content: space-between;">
                                    <div style="font-family: PingFang SC, PingFang SC;font-weight: bold;font-size: 14px;color: #333333;">本年度项目服务概况</div>
                                    <div @click="expandServe(1)" style="color: #337CFF;font-family: PingFang SC, PingFang SC;  font-weight: 500;font-size: 14px;display: flex;align-items: center;height: 20px;cursor: pointer;">
                                        <div style="margin-right: 4px;">{{serve1?'收起': '展开明细'  }}</div>
                                        <img v-if="serve1" src="//assets/images/takein.svg" alt="">
                                        <img v-else src="//assets/images/arrowD.svg" alt="">
                                        <!-- <img src="//assets/images/takein.svg" alt=""> -->
                                    </div>
                                </div>
                                <div style="display: flex;margin-bottom: 12px;">
                                    <div style="margin-right: 30px;" v-if="!noAuthCols.includes('AccumulateTimes')">
                                        <div class="word">累计实施次数</div>
                                        <div class="num">{{projectServiceData1.AccumulateTimes?projectServiceData1.AccumulateTimes:'0' }}</div>
                                    </div>
                                    <!-- <div v-if="!noAuthCols.includes('AccumulateDays')" style="margin-right: 30px;">
                                        <div class="word">累计实施天数</div>

                                        <div class="num">{{projectServiceData1.AccumulateDays?projectServiceData1.AccumulateDays:'--' }}</div>
                                    </div> -->
                                    <div v-if="!noAuthCols.includes('AccumulatePeoples')">
                                        <div class="word">累计实施人员</div>

                                        <div class="num">{{projectServiceData1.AccumulatePeoples?projectServiceData1.AccumulatePeoples:'--' }}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="fee">
                                <div style="display: flex;justify-content: space-between;">
                                    <div style="font-family: PingFang SC, PingFang SC;font-weight: bold;font-size: 14px;color: #333333;">上年度项目服务概况</div>
                                    <div @click="expandServe(2)" style="color: #337CFF;font-family: PingFang SC, PingFang SC;  font-weight: 500;font-size: 14px;display: flex;align-items: center;height: 20px;cursor: pointer;">
                                        <div style="margin-right: 4px;">{{serve2?'收起': '展开明细'  }}</div>
                                        <img v-if="serve2" src="//assets/images/takein.svg" alt="">
                                        <img v-else src="//assets/images/arrowD.svg" alt="">
                                        <!-- <img src="//assets/images/takein.svg" alt=""> -->
                                    </div>
                                </div>
                                <div style="display: flex;margin-bottom: 12px;">
                                    <div style="margin-right: 30px;" v-if="!noAuthCols.includes('AccumulateTimes')">
                                        <div class="word">累计实施次数</div> 

                                        <div class="num">{{projectServiceData2.AccumulateTimes?projectServiceData2.AccumulateTimes:'0' }}</div>
                                    </div>
                                    <!-- <div v-if="!noAuthCols.includes('AccumulateDays')" style="margin-right: 30px;">
                                        <div class="word">累计实施天数</div>

                                        <div class="num">{{projectServiceData2.AccumulateDays?projectServiceData2.AccumulateDays:'--' }}</div>
                                    </div> -->
                                    <div v-if="!noAuthCols.includes('AccumulatePeoples')">
                                        <div class="word">累计实施人员</div>

                                        <div class="num">{{projectServiceData2.AccumulatePeoples?projectServiceData2.AccumulatePeoples:'--' }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-if="projectList.length">
                            <div v-for="item in projectList" :key="item" style="margin: 20px 0;">
                            <div style="margin-bottom: 10px;font-weight: 700;">{{item.title}}</div>
                            <div style="display: flex;margin-bottom: 7px;">
                                <div class="title">实施人员</div>
                                <div class="detail">{{item.doPeople}}</div>
                            </div>
                            <div style="display: flex;margin-bottom: 7px;">
                                <div class="title">实施时间</div>
                                <div class="detail">{{item.doDate}}</div>
                            </div>
                            <div style="display: flex;margin-bottom: 7px;">
                                <div class="title">实施天数</div>
                                <div class="detail">{{item.doDays}}</div>
                            </div>
                            <div style="display: flex;margin-bottom: 7px;">
                                <div class="title">项目成果</div>
                                <div class="detail">{{item.achievement}}</div>
                            </div>
                            <div style="display: flex;margin-bottom: 7px;">
                                <div class="title">跟踪事项</div>
                                <div class="detail">{{item.unfinishedMatters}}</div>
                            </div>
                        </div>
                        </div>
                        <div v-if="!projectList.length&&(serve1||serve2)" class="nodata_box">
                            <img src="@/assets/images/index/nodata.png" />
                            <span class="txt">暂无更多~~~</span>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
        <el-dialog title="合作品种明细" :visible.sync="dialogTableVisible">
            <el-table :data="gridData" @sort-change="sortChange" max-height="500" show-summary :summary-method="getSummaries" border >
                <el-table-column sortable="custom" label="排序" type="index" width="80" align="center"></el-table-column>
                <el-table-column property="productName" label="商品名称" :show-overflow-tooltip="true" align="center"></el-table-column>
                <el-table-column property="norms" label="规格" :show-overflow-tooltip="true" align="center"></el-table-column>
                <el-table-column property="produceUnit" label="厂家" :show-overflow-tooltip="true" align="center"></el-table-column>
                <el-table-column sortable="custom" property="totalSum" label="销售数量" :show-overflow-tooltip="true" align="center"></el-table-column>
                <el-table-column sortable="custom" property="totalPay" label="销售金额" :show-overflow-tooltip="true" align="center"></el-table-column>
            </el-table>
            <div class="pagination_box">
                <el-pagination background layout="prev, pager, next, sizes, total" :page-sizes="[10, 20, 30, 40]" :page-size.sync="params.pageSize" :current-page.sync="params.page" :total="totals" @current-change="cooperateDetail" @size-change="cooperateDetail(1)">
                </el-pagination>
            </div>
        </el-dialog>
    </div>
</template>

<script>
// function cleanDataImmutable(data, keysToRemove) {
//   const keySet = new Set(keysToRemove);
//   return Object.keys(data).reduce((newData, subObjKey) => {
//     const subObj = data[subObjKey];
//     newData[subObjKey] = Object.keys(subObj).reduce((newSubObj, key) => {
//       if (!keySet.has(key)) newSubObj[key] = subObj[key];
//       return newSubObj;
//     }, {});
//     return newData;
//   }, {});
// }
export default {
    data() {
        return {
            activeName: 'first',
            baseInfo: {},
            fee1: false,
            fee2: false,
            serve1: false,
            serve2: false,
            dialogTableVisible: false,
            saleBackData: {},
            cooperateGoodsData: {},
            agreementTermsData: {},
            feeData1: {},
            feeData2: {},
            projectServiceData1: {},
            projectServiceData2: {},
            feeList: [],
            projectList: [],
            tabNum: '',
            params: {
                memberId: +this.$route.query.memberId,
                page: 1,
                pageSize: 20,
                tab: '',
                orderBy: "totalSum",
                sortMode: "desc",
            },
            params2: {
                memberId: +this.$route.query.memberId,
                year:''
            },
            params3: {
                memberId: +this.$route.query.memberId,
                year:''
            },
            paramsData: {
                memberId: +this.$route.query.memberId,
               page: 1,
               pageSize:10
            },
            totals: 0,
            totalData: 0,
            noAuthCols: [],
            profectList: [],
            gridData: [],
            summary: {},
        }
    },
    created() {
        this.getDetail()
        // this.getFee()
        // this.getProject()
        this.getProfect()
    },
    methods: {
        getSummaries(param) {
            const sums = [];
            sums[1] = '总计'
            sums[4] = this.summary.totalSum;
            sums[5] = this.summary.totalPay;


            // this.$nextTick(() => {
            //       // myTable是表格的ref属性值
            //       if (this.$refs.saleTable && this.$refs.saleTable.doLayout) {
            //         this.$refs.saleTable.doLayout();
            //       }
            //     });
            return sums;
        },
        async getDetail() {
            const res = await this.$api.customFilePcDetail({ memberId: +this.$route.query.memberId })
            if (res.data.code != 200) return
            this.noAuthCols = res.data.data.noAuthCols ? res.data.data.noAuthCols : []
            //     console.log(res);
            //     // removeKeysFromData(res.data.data, this.noAuthCols);
            //   if(this.noAuthCols.length){
            //     const cleanedData = cleanDataImmutable(res.data.data, this.noAuthCols);
            //     console.log(cleanedData);
            //     this.baseInfo = cleanedData.baseInfo ? cleanedData.baseInfo : []
            //     this.saleBackData = cleanedData.saleBackData

            //     this.cooperateGoodsData = cleanedData.cooperateGoodsData
            //     this.agreementTermsData = cleanedData.agreementTermsData
            //     this.feeData = cleanedData.feeData
            //     this.projectServiceData = cleanedData.projectServiceData
            //   }else{
            this.baseInfo = res.data.data.baseInfo ? res.data.data.baseInfo : []
            this.saleBackData = res.data.data.saleBackData

            this.cooperateGoodsData = res.data.data.cooperateGoodsData
            this.agreementTermsData = res.data.data.agreementTermsData
            this.feeData1 = res.data.data.thisYearFeeData
            this.feeData2 = res.data.data.lastYearFeeData
            this.projectServiceData1 = res.data.data.thisYearProjectServiceData
            this.projectServiceData2 = res.data.data.lastYearProjectServiceData
            //   }
        },
        async cooperateDetail(num) {
            if (num == 1) {
                this.params.page = 1
            }
            this.params.tab = this.tabNum
            const res = await this.$api.cooperateDetail(this.params)
            if (res.data.code == 200) {
                this.gridData = res.data.data.list
                this.summary = res.data.data.commonData
                this.totals = res.data.data.total
            }
            this.dialogTableVisible = true
        },
        //排序
        sortChange(column) {
            console.log(column);
            this.params.orderBy = column.prop
            this.params.sortMode = column.order == 'ascending' ? 'asc' : 'desc'
            //判断排序规则
            //   if (column.order) {
            //     if (column.order === 'descending') {
            //       this.queryParams.sortModelOrder = 'desc'
            //     } else if (column.order === 'ascending') {

            //       this.queryParams.sortModelOrder = 'asc'
            //     }

            //     this.queryParams.sortModelField = column.prop
            //   } else {

            //     this.queryParams.sortModelOrder = ''
            //     this.queryParams.sortModelField = ''
            //   }
            this.cooperateDetail();
        },
        expandFee(num) {
            if (num == 1) {
                this.fee1 = !this.fee1
                if(this.fee1){ 
                this.fee2 = false
                this.getFee()
              }else{
                this.feeList=[]
              }
                this.params2.year='thisYear'
            } else {
                 this.params2.year='lastYear'
                this.fee2 = !this.fee2
                if(this.fee2){ 
                this.fee1 = false
                this.getFee()
              }else{
                this.feeList=[]
              }
            }
           
        },
        expandServe(num) {
            if (num == 1) {
                 this.params3.year='thisYear'
                this.serve1 = !this.serve1
              if(this.serve1){ 
                this.serve2 = false
                this.getProject()
              }else{
                this.projectList=[]
              }
               
            } else {
                   this.params3.year='lastYear'
                this.serve2 = !this.serve2
                if(this.serve2){ 
                this.serve1 = false
                this.getProject()
              }else{
                this.projectList=[]
              }
            }
         
        },
        async getFee(num) {
            const res = await this.$api.customFeeList(this.params2)
            if (res.data.code != 200) return
            this.feeList = res.data.data.list ? res.data.data.list : []
        
        },
        async getProject() {
           
            const res = await this.$api.projectList(this.params3)
            if (res.data.code != 200) return
            this.projectList = res.data.data.list ? res.data.data.list : []
            // this.total2 = res.data.data.total
        },
        async getProfect(num) {
            if (num == 1) {
                this.paramsData.page = 1
            }
            const res = await this.$api.profectList(this.paramsData)
            if (res.data.code != 200) return
            res.data.data.list.forEach(item => {
                item.isShow = false
            })
            this.profectList = res.data.data.list ? res.data.data.list : []

            console.log(this.profectList);

            this.totalData = res.data.data.total
        },
        async expand(item, index) {
            item.isShow = !item.isShow
            const res = await this.$api.profectDetail({
                Id: item.Id,
                ContractNo: item.ContractNo,
                T: item.T
            })
            if (res.data.code != 200) return
            const tableOne = [
                {
                    RebackLv1: res.data.data.RebackLv1 ? res.data.data.RebackLv1 : '-',
                    RebackLv2: res.data.data.RebackLv2 ? res.data.data.RebackLv2 : '-',
                    AgreementMoney1: res.data.data.AgreementMoney1 ? res.data.data.AgreementMoney1 : '-',
                    AgreementMoney2: res.data.data.AgreementMoney2 ? res.data.data.AgreementMoney2 : '-',
                }
            ]
            if (item.isShow) {
                this.$set(this.profectList[index], 'Original', res.data.data.Original ? res.data.data.Original : '');
                this.$set(this.profectList[index], 'OriginalMoneyStr', res.data.data.OriginalMoneyStr ? res.data.data.OriginalMoneyStr : '');
                this.$set(this.profectList[index], 'SupplementaryClauses', res.data.data.SupplementaryClauses ? res.data.data.SupplementaryClauses : '');
                this.$set(this.profectList[index], 'RightsAgreement', res.data.data.RightsAgreement ? res.data.data.RightsAgreement : '');
                this.$set(this.profectList[index], 'RebackTime', res.data.data.RebackTime ? res.data.data.RebackTime : '');
                this.$set(this.profectList[index], 'RebackType', res.data.data.RebackType ? res.data.data.RebackType : '');
                this.$set(this.profectList[index], 'Content', res.data.data.Content ? res.data.data.Content : '');
                this.$set(this.profectList[index], 'TargetDetail', res.data.data.TargetDetail ? res.data.data.TargetDetail : '');
                this.$set(this.profectList[index], 'tableOne', tableOne ? tableOne : '');
                this.$set(this.profectList[index], 'ProductName', res.data.data.ProductName ? res.data.data.ProductName : '');
                this.$set(this.profectList[index], 'Price', res.data.data.Price ? res.data.data.Price : '');
                this.$set(this.profectList[index], 'Norms', res.data.data.Norms ? res.data.data.Norms : '');
            } else {
                delete this.profectList[index].Original
                delete this.profectList[index].OriginalMoneyStr
                delete this.profectList[index].SupplementaryClauses
                delete this.profectList[index].RightsAgreement
                delete this.profectList[index].RebackTime
                delete this.profectList[index].RebackType
                delete this.profectList[index].Content
                delete this.profectList[index].TargetDetail
                delete this.profectList[index].tableOne
                delete this.profectList[index].Norms
                delete this.profectList[index].Price
                delete this.profectList[index].ProductName

            }
            // this.$forceUpdate()
            console.log(this.profectList);

        }
    },
}
</script>
<style lang="scss">
.right3 .el-tabs .el-tabs__header {
    padding-left: 12px !important;
    margin: 0 !important;
}
.myTable .el-table__body-wrapper {
    height: calc(100% - 44px) !important;
}
.el-link.is-underline::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    height: 0;
    bottom: 0;
    border-bottom: 1px solid #1890ff;
}
</style>
<style scoped lang="scss">
.fee {
    width: 390px;
    height: 90px;
    background: #f6f6f6;
    border-radius: 10px 10px 10px 10px;
    padding: 10px 15px;
    box-sizing: border-box;
}
.word {
    font-family: PingFang SC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #a8a8a8;
}
.num {
    font-family: SFU DIN Mittelschrift, SFU DIN Mittelschrift;
    font-weight: 500;
    font-size: 19px;
    color: #333333;
}
.line {
    width: 100%;
    height: 0px;
    background: #ffffff;
    box-shadow: 0px 3px 6px 1px rgba(244, 244, 244, 0.16);
    border: 1px solid #f4f4f4;
    margin: 8px 0;
}
.title {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #999999;
    margin-right: 10px;
    width: 80px;
}
.title1 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #999999;
    margin-right: 10px;
    width: 90px;
}
.kindDetail {
    font-family: SFU DIN Mittelschrift, SFU DIN Mittelschrift;
    font-weight: 500;
    font-size: 27px;
    color: #222222;
    // text-align: center;
}
.kind {
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 400;
    font-size: 16px;
    color: #999999;
}
.detail {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #333333;
    flex: 1;
}
.fox {
    padding: 2px;
    border-radius: 3px;
    border: 1px solid;
    margin-right: 5px;
    font-size: 10px;
}
.box_title {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 18px;
    color: #333333;

    &::before {
        content: '';
        display: inline-block;
        width: 6px;
        height: 16px;
        background: #1a9dff;
        border-radius: 100px 100px 100px 100px;
        margin-right: 7px;
    }
}
.left {
    width: 363px;
    // height: 320px;
    background: #ffffff;
    border-radius: 2px 2px 2px 2px;
    margin-right: 13px;
    padding: 14px;
    height: 100%;
}
.right1 {
    width: 790px;
    height: 188px;
    background: #ffffff;
    border-radius: 2px 2px 2px 2px;
    margin-bottom: 13px;
    padding: 12px;
}
.right2 {
    width: 790px;
    height: 119px;
    background: #ffffff;
    border-radius: 2px 2px 2px 2px;
    margin-bottom: 13px;
    padding: 12px;
}
.right3 {
    width: 814px;
    // height: 256px;
    background: #fff;
    border-radius: 0px 0px 0px 0px;
}
.storeName {
    width: 338px;
    // height: 68px;
    padding: 10px;
    background-image: url(//assets/images/storeBg1.png);
    // background-position: 100% 100%;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    margin-bottom: 10px;
}
</style>
<style>
.el-tabs__nav-wrap::after{
    background-color: #f4f4f4 !important;
}
.el-tabs__active-bar{
    height: 3px !important;
}
</style>